import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.css";
import {
  faFacebook,
  faGithub,
  faYoutube,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
const Footer = () => {
  return (
    <footer>
      <Container fluid className="pt-3" style={{ backgroundColor: "#112240" }}>
        <Row className="justify-content-md-center">
          <Col xs="12" lg="5" className="mt-3 footer-title">
            <div className="text-center">
              <img
                style={{
                  height: "50px",
                }}
                src="https://i.ibb.co/hHjPLym/Mosheur-Rahman.png"
                alt=""
              />
            </div>
            <h5 className="text-center ms-2 my-3">
              &copy; {new Date().getFullYear()} Develope by ❤️ Mosheur Rahman.
            </h5>
          </Col>

          <Col xs="12" lg="2"></Col>

          <Col xs="12" lg="5" className="mt-3 mx-auto text-center pt-3">
            <Link to="/" className=" text-decoration-none footer-menu">
              Careers
            </Link>

            <Link to="/" className="text-decoration-none footer-menu">
              Resources
            </Link>
            <Link to="/" className="text-decoration-none footer-menu">
              Privacy
            </Link>
          </Col>
        </Row>
        <Row className="justify-content-md-center">
          <Col xs="12" lg="4" className="mx-auto text-center p-2 mb-3">
            <a
              href="https://www.facebook.com/mosheur.pau"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faFacebook} className="footer-icon" />
            </a>
            <a
              href="https://www.instagram.com/mosheur_mehedi"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faInstagram} className="footer-icon" />
            </a>
            <a
              href="https://github.com/mosheurpau"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faGithub} className="footer-icon" />
            </a>
            <a
              href="https://www.youtube.com/c/BasicProgrammer"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FontAwesomeIcon icon={faYoutube} className="footer-icon" />
            </a>

            <br />
            <h4>It's nothing too late to learn anything.</h4>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
